"use strict"

module.exports = require('./dist/es5/Scanner.js').default
module.exports.Token = require('./dist/es5/Token.js').default
